import React, { useState } from 'react';
import { useLanguage } from '../i18n';
import PublicLayout from '../components/PublicLayout';
import { VeloraLogo } from '../components/brand/Logos';
import { LessSugarIcon, NoPreservativesIcon, CleanIcon } from '../components/brand/Icons';
import { Sparkles, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';

export default function VeloraPage() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    // Stored locally for now — when product launches we'll connect to backend
    const list = JSON.parse(localStorage.getItem('velora_waitlist') || '[]');
    list.push({ email, ts: new Date().toISOString() });
    localStorage.setItem('velora_waitlist', JSON.stringify(list));
    toast.success(t('notifyMe') + ' ✓');
    setEmail('');
  };

  const advs = [
    { Icon: LessSugarIcon, label: t('advLessSugar') },
    { Icon: NoPreservativesIcon, label: t('advNoPreservatives') },
    { Icon: CleanIcon, label: t('advClean') },
  ];

  return (
    <PublicLayout>
      <section className="bg-[#F6E9E5] min-h-[80vh]" data-testid="velora-page">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-24 md:py-32 text-center">
          <span className="inline-flex items-center gap-1.5 text-[10px] tracking-widest uppercase font-bold px-3 py-1.5 bg-[#8E2A4E] text-[#F6E9E5] rounded-sm mb-10">
            <Sparkles className="h-3 w-3" /> {t('veloraSoon')}
          </span>
          <VeloraLogo size="lg" className="mb-8" />
          <h1 className="font-playfair italic text-4xl md:text-7xl text-[#8E2A4E] mb-6 leading-[0.95]">
            {t('tagVeloraSlogan')}
          </h1>
          <p className="text-base md:text-lg text-[#6E4D3A]/75 max-w-xl mx-auto leading-relaxed mb-16">{t('veloraCardDesc')}</p>

          {/* Anti-features */}
          <div className="grid grid-cols-3 gap-4 md:gap-6 max-w-2xl mx-auto mb-16">
            {advs.map(({Icon, label}, i) => (
              <div key={i} className="bg-[#F6F4EE] p-5 md:p-7 rounded-xl">
                <div className="text-[#8E2A4E] mb-3 inline-flex p-2 rounded-full bg-[#E8C5C8]/40"><Icon width={22} height={22} /></div>
                <p className="text-xs md:text-sm font-bold text-[#6E4D3A]">{label}</p>
              </div>
            ))}
          </div>

          {/* Email capture */}
          <form onSubmit={submit} className="max-w-md mx-auto" data-testid="velora-notify-form">
            <p className="eyebrow text-[#8E2A4E] mb-3"><Mail className="inline h-3 w-3 mr-1" /> {t('notifyMe')}</p>
            <div className="flex gap-2">
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid="velora-email"
                className="bg-[#F6F4EE] border-[#E8C5C8] focus:ring-[#8E2A4E] flex-1"
              />
              <Button type="submit" className="cff-button-velora px-6" data-testid="velora-notify-submit">
                {t('sendMessage')}
              </Button>
            </div>
          </form>
        </div>
      </section>
    </PublicLayout>
  );
}
